<mat-card appearance="outlined" style="margin-bottom: 20px">
  <h2>{{ 'contact.contact' | translate }}</h2>

  <div class="main-actions">
    <button (click)="addItem()" class="ibexfusion-raised-button small" mat-button>{{ 'contact.selectContact' | translate }}</button>
    <button (click)="addItem('contact', 'create')" class="ibexfusion-raised-button small" mat-button>{{ 'contact.createContact' | translate }}</button>
  </div>

  <div class="attached" *ngIf="selectedContact">
    <h3>{{ 'contact.connectedContact' | translate }}: {{selectedContact.title}}</h3>
    <div class="field-wrapper">
      <div class="fields">
        <mat-form-field>
          <mat-label>{{'contact.website' | translate}}</mat-label>
          <input [(ngModel)]="selectedContact.website" matInput [disabled]="true">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contact.email' | translate}}</mat-label>
          <input [(ngModel)]="selectedContact.email" matInput [disabled]="true">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contact.phone' | translate}}</mat-label>
          <input [(ngModel)]="selectedContact.phone" matInput [disabled]="true">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contact.fax' | translate}}</mat-label>
          <input [(ngModel)]="selectedContact.fax" matInput [disabled]="true">
        </mat-form-field>
      </div>
      <button (click)="selectedContact = null; dynamicContent.attachedContactId = null" mat-icon-button
              [matTooltip]="'contact.disconnectContact' | translate"><mat-icon>link_off</mat-icon>
      </button>
    </div>
  </div>

  <div class="input" *ngIf="!selectedContact">
    <mat-form-field>
      <mat-label>{{'contact.website' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.website" matInput >
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.email' | translate}}</mat-label>
      <input [(ngModel)]="contact.email" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.phone' | translate}}</mat-label>
      <input [(ngModel)]="contact.phone" matInput >
    </mat-form-field>
  </div>

</mat-card>

<mat-card appearance="outlined">
  <h2>{{ 'contact.address' | translate }}</h2>

  <div class="main-actions">
    <button (click)="addItem('address')" class="ibexfusion-raised-button small" mat-button>{{ 'contact.selectAddress' | translate }}</button>
    <button (click)="addItem('address', 'create')" class="ibexfusion-raised-button small" mat-button>{{ 'contact.createAddress' | translate }}</button>
  </div>

  <div class="attached" *ngIf="selectedAddress">
    <h3>{{ 'contact.connectedAddress' | translate }}: {{selectedAddress.title}}</h3>
    <div class="field-wrapper">
      <div class="fields">
        <mat-form-field>
          <mat-label>{{'contact.street' | translate}}</mat-label>
          <input [(ngModel)]="selectedAddress.street" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contact.zip' | translate}}</mat-label>
          <input [(ngModel)]="selectedAddress.zip" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contact.city' | translate}}</mat-label>
          <input [(ngModel)]="selectedAddress.city" matInput>
        </mat-form-field>
        <mat-form-field *ngIf="selectedAddress?.coordinates?.latitude">
          <mat-label>{{'contact.lat' | translate}}</mat-label>
          <input [(ngModel)]="selectedAddress.coordinates.latitude" matInput type="number">
        </mat-form-field>
        <mat-form-field *ngIf="selectedAddress?.coordinates?.longitude">
          <mat-label>{{'contact.lng' | translate}}</mat-label>
          <input [(ngModel)]="selectedAddress.coordinates.longitude" matInput type="number">
        </mat-form-field>
      </div>
      <button (click)="selectedAddress = null; dynamicContent.attachedAddressId = null" mat-icon-button
              [matTooltip]="'contact.disconnectAddress' | translate"><mat-icon>link_off</mat-icon>
      </button>
    </div>
  </div>

  <div class="input" *ngIf="!selectedAddress">
    <mat-form-field>
      <mat-label>{{'dynamicContent.street' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.location.address" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'dynamicContent.zip' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.location.zip" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'dynamicContent.city' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.location.city" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="dynamicContent?.content?.location?.coordinates?.latitude">
      <mat-label>{{'dynamicContent.lat' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.location.coordinates.latitude" matInput type="number">
    </mat-form-field>
    <mat-form-field *ngIf="dynamicContent?.content?.location?.coordinates?.longitude">
      <mat-label>{{'dynamicContent.lng' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.location.coordinates.longitude" matInput type="number">
    </mat-form-field>
  </div>

</mat-card>
